import httpSvc from './HttpSvc'
import { DS_ROUTES } from '@/core/constants'

export async function presignUrl(filename, nomination_id) {
  const resp = await httpSvc.post(DS_ROUTES.purple_ribbon_awards_file_presigned_url, { filename, nomination_id })
  return resp.data
}

export function confirmFileAdded(id, files) {
   return httpSvc.post(DS_ROUTES.purple_ribbon_awards_file_confirm, { id, files })
}

export async function getNominationFiles(id) {
  const resp = await httpSvc.post(DS_ROUTES.purple_ribbon_awards_nomination_files_get, { id })
  return resp.data.files
}

export async function removeFile(id) {
  return httpSvc.post(DS_ROUTES.purple_ribbon_awards_file_remove, { id })
}
